import { Roles } from "../../../constants/roles";
import { FormBase } from "../../../util/form-base-form";

export class BrandRecommendForm extends FormBase {
    public getEventTarget<T extends typeof Element>(event: Event, ctor: T): InstanceType<T> | null {
        return this.fromEventTarget(event, ctor) as InstanceType<T> | null;
    }

    public getOverlay(root: ParentNode = document): HTMLElement | null {
        return this.queryElement(root, `[data-role="${Roles.BRAND_RECOMMEND_MODAL_OVERLAY}"]`, HTMLElement);
    }

    public getModal(root: ParentNode = document): HTMLElement | null {
        return this.queryElement(root, `[data-role="${Roles.BRAND_RECOMMEND_MODAL}"]`, HTMLElement);
    }

    public getBody(root: ParentNode = document): HTMLElement | null {
        return this.queryElement(root, `[data-role="${Roles.BRAND_RECOMMEND_MODAL_BODY}"]`, HTMLElement);
    }

    public getListRoot(root: ParentNode = document): HTMLElement | null {
        return this.queryElement(root, `[data-role="${Roles.BRAND_RECOMMEND_MODAL_LIST}"]`, HTMLElement);
    }

    public getCloseButton(root: ParentNode = document): HTMLElement | null {
        return this.queryElement(root, `[data-role="${Roles.BRAND_RECOMMEND_MODAL_CLOSE}"]`, HTMLElement);
    }

    public getRemoveButton(root: ParentNode = document): HTMLButtonElement | null {
        return this.queryElement(root, '[data-action="select-clear"]', HTMLButtonElement);
    }

    public getModalButtons(root: ParentNode = document): HTMLButtonElement[] {
        return this.queryElements(root, "button", HTMLButtonElement);
    }

    public getRecommendButtons(root: ParentNode = document, brandId?: number): HTMLElement[] {
        const selector = brandId
            ? `[data-role="${Roles.BRAND_RECOMMEND_BTN}"][data-brand-id="${String(brandId)}"]`
            : `[data-role="${Roles.BRAND_RECOMMEND_BTN}"]`;
        return this.queryElements(root, selector, HTMLElement);
    }

    public getClosestRecommendButton(element: Element | null | undefined): HTMLElement | null {
        if (!(element instanceof Element)) return null;
        return this.closest(element, `[data-role="${Roles.BRAND_RECOMMEND_BTN}"]`, HTMLElement);
    }

    public getRecommendCapabilityHost(element: Element | null | undefined): HTMLElement | null {
        if (!(element instanceof Element)) return null;
        return this.closest(element, '[data-can-recommend="1"]', HTMLElement);
    }

    public getBrandCard(element: Element | null | undefined): HTMLElement | null {
        if (!(element instanceof Element)) return null;
        return this.closest(element, `[data-role="${Roles.BRAND_CARD}"]`, HTMLElement);
    }

    public getOverlayHost(element: Element | null | undefined): HTMLElement | null {
        if (!(element instanceof Element)) return null;
        return this.closest(element, `[data-role="${Roles.BRAND_RECOMMEND_MODAL_OVERLAY}"]`, HTMLElement);
    }

    public getCloseAction(element: Element | null | undefined): HTMLElement | null {
        if (!(element instanceof Element)) return null;
        return this.closest(element, '[data-action="recommend-close"]', HTMLElement);
    }

    public getUnsetAction(element: Element | null | undefined): HTMLButtonElement | null {
        if (!(element instanceof Element)) return null;
        return this.closest(element, '[data-action="recommend-unset"]', HTMLButtonElement);
    }

    public getRankAction(element: Element | null | undefined): HTMLButtonElement | null {
        if (!(element instanceof Element)) return null;
        return this.closest(element, '[data-action="recommend-rank"][data-rank]', HTMLButtonElement);
    }

    public getBadgeRank(root: ParentNode): HTMLElement | null {
        return this.queryElement(root, `[data-role="${Roles.BRAND_RECOMMEND_BADGE_RANK}"]`, HTMLElement);
    }
}

export const brandRecommendForm = new BrandRecommendForm();
